import dosageModel from "@models/dosageModel.js";
import {cloneDeep} from "es-toolkit";

export default {
  id: null,
  dosage: cloneDeep(dosageModel),
  indication_unknown: 0,
  indications: [],
  usage: null,
};
